const ScaleTypes = {
    MAIN: "main",
    SUB: "sub",
};

export default ScaleTypes;
